interface Options {
	element?: string;
	class?: string;
	callback?: (() => void) | null;
}

const breakElementLines = (options: Options = {}) => {
	const defaults = {
		element: '.has-heading-highlight-color',
		class: 'underline',
		callback: null,
	};

	options = Object.assign({}, defaults, options);
	if (!options.element) {
		return;
	}
	const elements = Array.from(document.querySelectorAll(options.element));

	elements.forEach((element) => {
		if (element.textContent) {
			const parentNode = element.parentNode;
			if (parentNode && options.element) {
				let parent = parentNode as HTMLElement;
				const parentTag = parent.tagName.toLowerCase();
				if ('mark' === parentTag || 'em' === parentTag) {
					parent = parent.parentNode as HTMLElement;
				}
				parent.classList.add('parent--' + options.element.split('.').join(''));
			}

			if (element.querySelector('a')) {
				element = element.querySelector('a') as HTMLElement;
			}

			const textContent = element.textContent ?? '';
			const text = textContent.split(' ');
			element.innerHTML = '<span>' + text.join('</span> <span>') + '</span>';
			let spanOffset: boolean | number = false;
			let newlineContent = '';
			const lines = [];

			const spans = Array.from(element.querySelectorAll('span'));
			spans.forEach((span) => {
				const currentSpanOffset = span.offsetTop;
				if (spanOffset === false) spanOffset = currentSpanOffset;

				if (currentSpanOffset !== spanOffset && newlineContent) {
					lines.push(newlineContent.trim());
					newlineContent = '';
					spanOffset = currentSpanOffset;
				}

				newlineContent += span.textContent + ' ';
			});

			lines.push(newlineContent.trim());
			element.innerHTML =
				'<span class="' +
				options.class +
				'">' +
				lines.join('</span> <span class="' + options.class + '">') +
				'</span>';
		}
	});

	if (options.callback) options.callback();
};
export default breakElementLines;
